import styled from "styled-components";

export const CataloguePageDiv = styled.div`
  background: #fff;
  min-height: calc(100vh - 120px);
  padding: 16px 24px 24px;
`;

export const CatalogueToolbarDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-bottom: 16px;

  button {
    border: none;
    background: transparent;
    color: #1249bf;
    font-size: 14px;
    font-weight: 500;
    padding: 6px 10px;
    cursor: pointer;

    &:disabled {
      color: #8c8ca1;
      cursor: not-allowed;
    }
  }
`;

export const CatalogueTableWrapDiv = styled.div`
  border: 1px solid #e9edf5;
  overflow: auto;
  max-height: calc(100vh - 260px);
`;

export const CatalogueTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 10px 12px;
    border-bottom: 1px solid #e9edf5;
    text-align: left;
    vertical-align: middle;
    font-size: 14px;
  }

  th {
    color: #5c5c77;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.36px;
    text-transform: uppercase;
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 1;
  }
`;

export const StatusBadgeSpan = styled.span`
  display: inline-block;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  color: ${props => (props.$listed ? "#0f7b3a" : "#b42318")};
  background: ${props => (props.$listed ? "#e8f8ef" : "#fdebec")};
`;

export const LocationPillSpan = styled.span`
  display: inline-block;
  margin: 2px 4px 2px 0;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 500;
  color: #1249bf;
  background: #e8eefc;
`;

export const CatalogueFooterDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  color: #5c5c77;
  font-size: 13px;

  .pager {
    display: flex;
    gap: 8px;
    align-items: center;

    button {
      border: 1px solid #e9edf5;
      background: #fff;
      padding: 4px 10px;
      cursor: pointer;

      &:disabled {
        color: #8c8ca1;
        cursor: not-allowed;
      }
    }
  }
`;

export const LinkedProductsAlertsDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0 24px 12px;
`;

export const CatalogueEmptyDiv = styled.div`
  padding: 48px 24px;
  text-align: center;

  .title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .desc {
    color: #8c8ca1;
    font-size: 14px;
    margin-bottom: 16px;
  }
`;

export const ModalBodyDiv = styled.div`
  padding: 8px 0 16px;

  .hint {
    color: #8c8ca1;
    font-size: 13px;
    margin-bottom: 12px;
  }

  .warehouseOption {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 0;
  }
`;
